import { IPreparedNote } from "@fokused-me/core";
import { markdownRenderer } from "@fokused-me/web-ui";
import { List } from "immutable";

function html(startNoteId: string, noteProvider: INoteProvider) {
   const hierarchyHtml = (noteId: string) => {
      const note = noteProvider.getNote(noteId) as IPreparedNote;
      let text = note.text || "";
      if (text) {
         text = markdownRenderer.render(text);
      }

      const htmlItems = [
         "<ul>",
         '<li class="note-content"><h1>',
         note.title,
         '</h1><div class="rich-content">',
         text,
         "</div></li>",
      ];

      const childrenIds = noteProvider.getChildrenIds(note.id);
      if (childrenIds.size) {
         htmlItems.push(childrenIds.map((it) => hierarchyHtml(it)).join(""));
      }

      htmlItems.push("</ul>");
      return htmlItems.join("");
   };

   const hierarchyObject = (noteId: string) => {
      const note = noteProvider.getNote(noteId) as IPreparedNote;
      const text = note.text || "";

      const info: any = {
         id: note.id,
         created: note.created,
         updated: note.updated,
      };

      if (note.title) {
         info.title = note.title.replace(/>/g, "&gt;");
      }

      if (text) {
         info.text = text.replace(/>/g, "&gt;");
      }

      delete info.extras;

      // if (text) {
      //    info.text = text.replace(/&nbsp;?/g, ' ')
      //       .replace(/&amp;?/g, '&')
      //       .replace(/&.{1}dash;?/g, '-')
      //       .replace(/<br\s*\/?>/g, '\n')
      //       .replace(/&lt;?/g, '<')
      //       .replace(/&gt;?/g, '>');
      // }

      const childrenIds = noteProvider.getChildrenIds(note.id);
      if (childrenIds.size) {
         info.children = childrenIds.map((it) => hierarchyObject(it));
      }

      return info;
   };

   const json = hierarchyObject(startNoteId);

   return `<!DOCTYPE html>
<html lang="en">
<!--
Memability-notes:
${JSON.stringify(json)}
-->
   <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=3.0, user-scalable=yes">
      <title>Memz One - Export "' + note.title + '"</title>
      <style>
         * {
            font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
            line-height: 1.6;
         }

         .completed {text-decoration: line-through; color: rgba(0,0,0,0.30);}

         .rich-content table, td, th {
            border: 1px solid rgba(0,0,0,0.12);
            border-spacing: 0;
            border-collapse: collapse;
         }

         .rich-content td, th {
            padding: 5px 10px;
         }

         .rich-content th {
            background-color: rgba(0,0,0,0.06);
         }

         .rich-content blockquote {
            border-left: 0.25em solid rgba(0,0,0,0.12);
            margin: 0;
            padding: 0 1em;
         }

         .rich-content code {
            font-family:"Lucida Console", "Courier New", monospace;
            background-color: rgba(0,0,0,0.06);
            border-radius: 3px;
            padding: 0 0.5em;
            display: inline-block;
         }

         .rich-content pre>code {
            display: block;
            padding: 0.6em;
         }

         .rich-content pre {
            white-space: pre-wrap;
         }

         .rich-content hr {
            border-top: 1px solid rgba(0,0,0,0.06);
         }

         .note-content {
            border: 1px dashed rgba(0,0,0,0.10);
            padding: 5px;
            margin-bottom: 10px;
         }
      </style>
   </head>
   <body>${hierarchyHtml(startNoteId)}</body>
</html>`;
}

export interface INoteProvider {
   getChildrenIds(noteId: string): List<string>;
   getNote(noteId: string): Readonly<IPreparedNote> | undefined;
}

export const exportNotes = (noteId: string, noteProvider: INoteProvider) => html(noteId, noteProvider);
